<!--
 * @Description: 服务配置详情组件
 * @Author: sunhuihong
 * @Date: 2022-05-26 08:28:58
 * @LastEditTime: 2023-12-25 13:23:19
-->
<template>
  <div class="body">
    <el-dialog  width="1200px" :title="dialogTitle" :visible.sync="showHsvcCfgDetails" 
      :close-on-click-modal="false" @open="initData" :before-close='handleHsvcCfgCancel' center>
      <div id="dialog-content" class="hsvc-content">
        <el-steps :active="active" finish-status="success" align-center style="padding: 0 100px">
          <el-step title="基本信息" :status="stepStatus(0)"></el-step>
          <el-step title="服务内容" :status="stepStatus(1)"></el-step>
          <el-step title="服务事项" :status="stepStatus(2)"></el-step>
          <el-step title="服务套餐" :status="stepStatus(3)"></el-step> 
        </el-steps>
        <div class="dialog-body">
          <baseinfo-panel     v-if="active == 0" @panel-operate="handleHsvcCfgPanelOperate"/>
          <service-content-panel  v-if="active == 1" @panel-operate="handleHsvcCfgPanelOperate"/>
          <service-items-panel   v-if="active == 2" @panel-operate="handleHsvcCfgPanelOperate"/>
          <service-package-panel    v-if="active == 3" @panel-operate="handleHsvcCfgPanelOperate"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import hsvcCfgBaseInfoPanel from "./hsvcCfgDetails/HsvcCfgBaseInfoPanel.vue";
import hsvcCfgServiceContentPanel from "./hsvcCfgDetails/HsvcCfgServiceContentPanel";
import hsvcCfgServiceItemsPanel from "./hsvcCfgDetails/HsvcCfgServiceItemsPanel";
import hsvcCfgServicePackagePanel from "./hsvcCfgDetails/HsvcCfgServicePackagePanel";
import hsvcCfgDetailStore from './hsvcCfgDetails/HsvcCfgDetailStore'

let HsvcCfgDetails = {
  name: 'HsvcCfgDetails',
  components: { 
    'baseinfo-panel': hsvcCfgBaseInfoPanel,
    'service-content-panel': hsvcCfgServiceContentPanel,
    'service-items-panel' : hsvcCfgServiceItemsPanel,
    'service-package-panel': hsvcCfgServicePackagePanel,
  },
  hsvcCfgDetailStore,
  props: ["showHsvcCfgDetails", "mode", "hsvcCfgItemId"],

  data() {
    return {
      active: 0,
    }
  },

  computed: {
    dialogTitle() {
      switch (this.mode) {
        case 'add'    : return "新增服务";
        case 'edit'   : return "编辑服务";
        case 'details': return "服务详情";
        default       : return "----";
      } 
    },
    
    stepStatus() {
      return function(curActive) {
        return (curActive <= this.active) ? 'finish' : 'wait';
      }
    },
  },

  methods: {
    initData() {
      this.clearData();
      hsvcCfgDetailStore.commit("changeMode", this.mode);
      this.active = 0;
      this.queryData();
    },

    queryData() {
      let url = '';
      switch (this.mode) {
        case 'add': 
          url = Constant.URL_GET_HSERVICE_CFG_DO_4_ADD
          break;
        case 'edit': 
          url = Constant.URL_GET_HSERVICE_CFG_DO_4_UPDATA;
          break;
        case 'details': 
          url = Constant.URL_GET_HSERVICE_CFG_DETAILS;
          break;
      }
      let params = this.mode == 'add' ? {} : {id: this.hsvcCfgItemId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          let hsvcDo = result.data;
          if (this.mode == 'details') {
            hsvcCfgDetailStore.commit("changeServiceCfg", hsvcDo.hserviceCfg);
            hsvcCfgDetailStore.commit('changeServiceItemCfgList', hsvcDo.hserviceItemCfgList);
            hsvcCfgDetailStore.commit('changeMatterCfgBaseInfoDO', hsvcDo.hserviceCfgMatterCfgList);
            hsvcCfgDetailStore.commit('changeServicePkgCfgList', hsvcDo.hservicePkgCfgList); 
            hsvcCfgDetailStore.commit('changeModeMapCfg', hsvcDo.modeMap); 
          } else {
            hsvcCfgDetailStore.commit("changeServiceCfgBaseInfoDO", hsvcDo.hserviceCfgBaseInfoDO);
            hsvcCfgDetailStore.commit("changeServiceCfg", hsvcDo.hserviceCfgBaseInfoDO.hserviceCfg);
            hsvcCfgDetailStore.commit('changeSvcTypeCfgDOList', hsvcDo.hserviceCfgBaseInfoDO.hsvcTypeCfgDOList);
            hsvcCfgDetailStore.commit('changeSloganList', hsvcDo.hserviceCfgBaseInfoDO.sloganList);
            hsvcCfgDetailStore.commit('changeModeMapCfg', hsvcDo.hserviceCfgBaseInfoDO.modeMap); 
            hsvcCfgDetailStore.commit('changeServiceItemCfgList', hsvcDo.hserviceItemCfgList);
            hsvcCfgDetailStore.commit('changeMatterCfgBaseInfoDO', hsvcDo.hserviceCfgMatterCfgList);
            hsvcCfgDetailStore.commit('changeServicePkgCfgList', hsvcDo.hservicePkgCfgList); 
          }
          if (this.mode == 'add') {
            this.clearOrignData(hsvcDo);
          }
        }
      })

    },
    
    clearOrignData() {
      hsvcCfgDetailStore.state.serviceCfg.startDuration = '';
      hsvcCfgDetailStore.state.serviceCfg.endDuration = '';
      hsvcCfgDetailStore.state.serviceCfg.hserviceTypeCfgId = '';
      hsvcCfgDetailStore.state.serviceCfg.sloganCfgId = '';
      hsvcCfgDetailStore.state.serviceCfg.mode = 3;
      hsvcCfgDetailStore.state.servicePkgCfgList[0].curPriceYuan = '';
      hsvcCfgDetailStore.state.servicePkgCfgList[0].originalPriceYuan = '';
      hsvcCfgDetailStore.state.servicePkgCfgList[0].serviceDuration = ''; 
    },
    
    clearData() {
      this.active = 0;
      hsvcCfgDetailStore.commit('changeServiceCfg', {});
      hsvcCfgDetailStore.commit('changeUserFile',null);  
      hsvcCfgDetailStore.commit('changeServiceFile',null);    
    },

    handleHsvcCfgPanelOperate(opr) {
      document.getElementById("dialog-content").scrollTop = 0;
      switch(opr) {
        case 'prev': 
          this.handleHsvcCfgPrev();
          break;
        case 'next':
          this.handleHsvcCfgNext();
          break;
        case 'ok':
          this.handleHsvcCfgCancel();
          break;
        case 'add':
        case 'edit':
          this.handleHsvcCfgSubmit(opr);
          break;
        case 'cancel':
          this.handleHsvcCfgCancel();
          break;
      }
    },

    handleHsvcCfgPrev() {
      if (this.active > 0) this.active--;
    },

    handleHsvcCfgNext() {
      if (this.active < 3) this.active++;
    },
    
    handleHsvcCfgSubmit(_opr) {
      this.$emit("close-dialog", false);
      let url = (this.mode == 'add') ? Constant.URL_SAVE_HSERVICE_CFG : Constant.URL_UPDATE_HSERVICE_CFG;
      let method = (this.mode == 'add') ? 'POST' : 'PUT';
      let hserviceCfgData = hsvcCfgDetailStore.state.serviceCfg;
      let obj = {
        "hserviceCfg": hserviceCfgData,
        "hserviceCfgMatterCfgList": hsvcCfgDetailStore.state.matterCfgBaseInfoDO,
        "hserviceItemCfg": hsvcCfgDetailStore.state.serviceItemCfgList,
        "hservicePkgCfgList": hsvcCfgDetailStore.state.servicePkgCfgList};
      let fileMap = new Map();
      if (hsvcCfgDetailStore.state.userFile && hsvcCfgDetailStore.state.userFile.raw) {
        fileMap.set('suitableImageFile', hsvcCfgDetailStore.state.userFile.raw);
      }
      if (hsvcCfgDetailStore.state.serviceFile&&hsvcCfgDetailStore.state.serviceFile.raw) {
        fileMap.set('svcImageFile', hsvcCfgDetailStore.state.serviceFile.raw);
      }
      let param = {'name': 'hserviceCfgVO', 'value': {...obj}};
      let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				param, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        url: url,
        method: method,
        header: header,
        param: esParams,
        files: fileMap,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.clearData();
        this.$emit("close-dialog", true);
      })    
    },

    handleHsvcCfgCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },
  },
}
export default HsvcCfgDetails
</script>

<style scoped>
.dialog-body {
  padding: 0;
  margin:0;
}

.hsvc-content {
  max-height: 75vh; 
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvccfg/components/HsvcCfgDetails.vue